"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _pclnDesignSystem = require("pcln-design-system");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var Peel = _styledComponents["default"].div.withConfig({
  componentId: "mto4pl-0"
})(["position:absolute;display:block;width:0;top:0;right:0;border-width:8px;border-style:solid;border-color:#5c5c5c #5c5c5c #ffef8b #ffef8b;border-radius:0 4px 0 4px;transition:border-width:130ms ease-in-out 0s;"]);

var ButtonContainer = (0, _styledComponents["default"])(_pclnDesignSystem.Button).withConfig({
  componentId: "mto4pl-1"
})(["position:relative;display:flex;justify-content:center;width:220px;height:50px;font-size:16px;font-weight:bold;color:#353535;background-color:#ffc800;border-radius:2px;:hover{color:#ffc800;background-color:#000;", "{border-width:12px;}}"], Peel);
var PeelButton = (0, _react.memo)(function (_ref) {
  var className = _ref.className,
      onClick = _ref.onClick,
      children = _ref.children;
  return _react["default"].createElement(ButtonContainer, {
    className: className,
    onClick: onClick
  }, children, _react["default"].createElement(Peel, null));
});
PeelButton.displayName = 'PeelButton';
PeelButton.propTypes = {
  className: _propTypes["default"].string,
  onClick: _propTypes["default"].func,
  children: _propTypes["default"].node
};
PeelButton.defaultProps = {
  className: ''
};
var _default = PeelButton;
exports["default"] = _default;